import { defineStore } from "pinia";
import { getShippingMethodes } from "@/api/auth";

export const useShippingMethodesStore = defineStore("ShippingMethodes", {
  state: () => ({
    shipping_methodes: [],
    firstcall: true,
    loading: false,
    error: null,
  }),
  getters: {
    ShippingMethodes: state => state.shipping_methodes ?? [],
  },
  actions: {
    async fetchShippingMethodes(userRole , vetId = null) {
      if (this.firstcall) this.loading = true;
      try {
        getShippingMethodes(userRole, vetId)
          .then(response => {
            this.shipping_methodes = response.data;
            if (this.firstcall) {
              this.firstcall = false;
              this.loading = false;
            }
          })
          .catch(() => {});
      } catch {
        this.error = "Erreur lors du chargement des shipping methodes";
      }
    },
  },
});
